import { useState, useEffect } from 'react';

const CustomizationTab = ({ userEditDisplayName, caregiverChgGroupEnabled, caregiverChgToneEnabled, onSave, saving }) => {
    const [displayName, setDisplayName] = useState(!!userEditDisplayName);
    const [group, setGroup] = useState(!!caregiverChgGroupEnabled);
    const [tone, setTone] = useState(!!caregiverChgToneEnabled);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        setDisplayName(!!userEditDisplayName);
        setGroup(!!caregiverChgGroupEnabled);
        setTone(!!caregiverChgToneEnabled);
        setDirty(false);
    }, [userEditDisplayName, caregiverChgGroupEnabled, caregiverChgToneEnabled]);

    const handleSave = () => {
        onSave({
            UserEditDisplayName: displayName,
            CaregiverChgGroupEnabled: group,
            CaregiverChgToneEnabled: tone,
        });
    };

    const toggles = [
        {
            key: 'display',
            title: 'Display Name',
            desc: 'Users can change their display name.',
            value: displayName,
            onChange: () => { setDisplayName(!displayName); setDirty(true); },
        },
        {
            key: 'group',
            title: 'Group',
            desc: 'Users can change the group of alerts they receive.',
            value: group,
            onChange: () => { setGroup(!group); setDirty(true); },
        },
        {
            key: 'tone',
            title: 'Alert Tone',
            desc: 'Users can set their own notification sound for alerts.',
            value: tone,
            onChange: () => { setTone(!tone); setDirty(true); },
        },
    ];

    return (
        <div className="pp-section">
            <div className="pp-section__header">
                <h3 className="pp-section__title">User Customizations</h3>
                {dirty ? (
                    <div className="pp-section__actions">
                        <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                            {saving ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                ) : null}
            </div>
            <div className="pp-section__body">
                {toggles.map((t) => (
                    <div key={t.key} className="ss-toggle-row">
                        <div className="ss-toggle-row__info">
                            <h4 className="ss-toggle-row__title">{t.title}</h4>
                            <p className="ss-toggle-row__desc">{t.desc}</p>
                        </div>
                        <div className="ss-toggle-row__control">
                            <div
                                className={`ss-toggle__track${t.value ? ' is-active' : ''}`}
                                onClick={t.onChange}
                                role="switch"
                                aria-checked={t.value}
                                tabIndex={0}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.onChange(); } }}
                            >
                                <div className="ss-toggle__knob" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomizationTab;
